import { PracticeAuthorizationResponse } from "@shared/dtos/responses/practiceResponses.dto"

import { axiosAuth } from "./generic/AxiosInterceptor/AxiosInterceptor"

export const getAllPracticeAuthorizations = async (practiceId: string): Promise<PracticeAuthorizationResponse[]> => {
  const resp = await axiosAuth({
    url: `/practiceauthorizations`,
    method: "get",
    params: {
      practiceId,
    },
  })
  return resp.data
}

export const updatePracticeAuthorization = (
  practiceAuthorizationId: string,
  configurationAccess: boolean
): Promise<void> => {
  return axiosAuth({
    url: `/practiceauthorizations/${practiceAuthorizationId}`,
    method: "patch",
    data: { configurationAccess },
  }).then(() => undefined)
}

export const removePracticeAuthorization = (practiceAuthorizationId: string): Promise<void> => {
  return axiosAuth({
    url: `/practiceauthorizations/${practiceAuthorizationId}`,
    method: "delete",
  }).then(() => undefined)
}

export const reactivatePracticeAuthorization = (practiceAuthorizationId: string): Promise<void> => {
  return axiosAuth({
    url: `/practiceauthorizations/${practiceAuthorizationId}/reactivate`,
    method: "patch",
  }).then(() => undefined)
}
